export const WebsiteData = [
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
    },
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
  
    },
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  
  
    },
    {   
        image:  "images/website.svg" ,
        website:"https://www.figma.com/exit?url=https%3A%2F%2Fplusvans.co.uk%2Fbookings%2F"  

    },
]